/* eslint-disable @typescript-eslint/no-explicit-any */

import { FormConfig, ManagementType, StateConfig } from './config'

const getFormElementConfig =
  (config: any) =>
  (name: string): FormConfig[0] => {
    const formElement = config.formElements[name]
    if (!formElement) throw new Error(`No form element configured for ${name}`)

    return formElement
  }

export const mapJsonToConfiguration = (config: any): StateConfig => {
  const getFormElement = getFormElementConfig(config)

  return {
    ...config,
    account: config.account?.map(getFormElement) ?? [],
    productConfig: Object.entries(config.productConfig).reduce(
      (acc, [schemeCode, productConfig]: [string, any]) => ({
        ...acc,
        [schemeCode]: {
          ...productConfig,
          coverOptions: productConfig.coverOptions?.map((coverOption: any) => ({
            ...coverOption,
            covers: {
              ...(coverOption.covers ?? {}),
              optional: coverOption.covers.optional?.map((optionalCover: any) => ({
                ...optionalCover,
                form: optionalCover.form?.map(getFormElement),
              })),
            },
          })),
          renewal: {
            ...productConfig.renewal,
            sections:
              productConfig.renewal?.sections?.map((it: any) => ({
                ...it,
                form: it.form?.map(getFormElement) ?? [],
              })) ?? [],
          },
          management:
            productConfig.management?.map((it: any) => ({
              ...it,
              form: it.form?.map(getFormElement) ?? [],
            })) ?? [],
          summary:
            productConfig.summary?.map((it: any) => ({
              ...it,
              form: it.form?.map(getFormElement) ?? [],
            })) ?? [],
          prefill: productConfig.prefill
            ? {
                ...productConfig.prefill,
                form: productConfig.prefill.form?.map(getFormElement),
              }
            : undefined,
          disclosures:
            productConfig.disclosures?.map((it: any) => {
              switch (it.type) {
                case ManagementType.PROMOTION:
                  return {
                    ...it,
                    promotions: Object.entries(it.promotions).reduce(
                      (acc, [promoCode, promotion]: [string, any]) => ({
                        ...acc,
                        [promoCode]: {
                          ...promotion,
                          form: promotion.form?.map(getFormElement) ?? [],
                        },
                      }),
                      {},
                    ),
                  }
                default:
                  return {
                    ...it,
                    form: it.form?.map(getFormElement) ?? [],
                  }
              }
            }) ?? [],
          proposalConfirmation: productConfig?.proposalConfirmation
            ? {
                ...(productConfig?.proposalConfirmation ?? {}),
                form: productConfig.proposalConfirmation?.form?.map(getFormElement) ?? [],
              }
            : undefined,
          proposalSave: productConfig.proposalSave?.map(getFormElement) ?? [],
          accountSetup: productConfig.accountSetup?.map(getFormElement) ?? [],
          expiredProposal: productConfig.expiredProposal?.map(getFormElement) ?? [],
          quoteDetails: productConfig.quoteDetails?.map(getFormElement) ?? [],
          beforeWeBegin: productConfig.beforeWeBegin?.map(getFormElement),
          finalMile: productConfig?.finalMile
            ? {
                form: productConfig.finalMile.form?.map(getFormElement),
                validationProfile: productConfig.finalMile.validationProfile,
              }
            : undefined,
        },
      }),
      {},
    ),
  }
}
